module.exports = __webpack_public_path__ + "img/9791187886242.9af67040.jpg";